import * as React from 'react';
import styled from 'styled-components';
import { EyeIcon } from '@estee/elc-icons';
import { EyeIconTheme } from '../theme/default-theme';

const RevealPass = styled.div`
    float: right;
    position: relative;
    bottom: 38px;
    right: 16px;
    height: 0;
    outline: none;
    user-select: none;

    &:hover {
        cursor: pointer;
    }

    [dir='rtl'] & {
        right: auto;
        float: left;
        left: 10px;
    }
`;

const StyledEyeIcon = styled(EyeIcon)`
    width: 24px;
    height: 24px;
    ${EyeIconTheme};
`;

export interface IRevealPasswordProps {
    showPasswordLabel?: string;
    showPasswordDataTestId?: string;
    isCrossed: boolean;
    onClick(): void;
}

export const RevealPassword = (props: IRevealPasswordProps) => {
    const handleToggleKeyEnter = (e: React.KeyboardEvent<HTMLDivElement>) => {
        const enterKeyCode = 13;
        if (e.which === enterKeyCode) {
            props.onClick();
        }
    };

    return (
        <RevealPass
            title={props.showPasswordLabel}
            aria-label={props.showPasswordLabel}
            aria-pressed={!props.isCrossed}
            role="button"
            data-test-id={props.showPasswordDataTestId}
            onClick={props.onClick}
            onKeyPress={handleToggleKeyEnter}
            tabIndex={0}
        >
            <StyledEyeIcon isCrossed={props.isCrossed} />
        </RevealPass>
    );
};
